import { default as MuiTabScrollButton } from '@mui/material/TabScrollButton';

/**
 * TabScrollButton renders the scroll buttons in scrollable Tabs.
 *
 * Demos:
 *
 * - [Tabs](https://unify.workiva.org/components/tabs?tab=code)
 *
 * API:
 *
 * - [TabScrollButton API](https://unify.workiva.org/components/tabs?tab=props#tabscrollbutton)
 */
export const TabScrollButton = MuiTabScrollButton;
export {
  type TabScrollButtonProps,
  tabScrollButtonClasses,
} from '@mui/material/TabScrollButton';
